/**
 * Puts the AMP Back in Stock widget in the site font.
 *
 * The widget's modal is written into an `about:blank` iframe (#BIS_frame), and
 * a document does not inherit its parent's stylesheets, so theme CSS never
 * reaches it — the rules have to be copied in. The @font-face declarations go
 * with them: a face loaded by the parent is not available inside the frame.
 *
 * The frame is same-origin, so this is a read of our own document. The app
 * rewrites the frame's contents as the shopper moves through it, which drops
 * the injected style, hence the observers that put it back.
 */
(function () {
  var FRAME_ID = 'BIS_frame';
  var STYLE_ID = 'mb-bis-font';
  var FONT_STACK = "'PP Mori', sans-serif";

  var fontFaces = null;

  /** Copy the site's PP Mori @font-face rules out of the theme's own CSS. */
  function siteFontFaces() {
    if (fontFaces !== null) return fontFaces;

    fontFaces = '';

    Array.prototype.forEach.call(document.styleSheets, function (sheet) {
      var rules;

      // Stylesheets from other origins throw on access; skip them.
      try {
        rules = sheet.cssRules;
      } catch (error) {
        return;
      }

      Array.prototype.forEach.call(rules || [], function (rule) {
        if (rule.type === 5 && /PP Mori/i.test(rule.cssText)) {
          fontFaces += rule.cssText + '\n';
        }
      });
    });

    return fontFaces;
  }

  function applyTo(frame) {
    var doc;

    try {
      doc = frame.contentDocument;
    } catch (error) {
      return;
    }

    if (!doc || !doc.head || doc.getElementById(STYLE_ID)) return;

    var style = doc.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      siteFontFaces() +
      'html, body, #BISModal, #BISModal *, .modal, .modal * {' +
      '  font-family: ' +
      FONT_STACK +
      ' !important;' +
      '}';

    doc.head.appendChild(style);

    watchContents(doc);
  }

  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;

  /** The app replaces the modal's markup as the shopper moves through it. */
  function watchContents(doc) {
    if (!watched || watched.has(doc)) return;
    watched.add(doc);

    new MutationObserver(function () {
      var frame = document.getElementById(FRAME_ID);
      if (frame) applyTo(frame);
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }

  function hookUp() {
    var frame = document.getElementById(FRAME_ID);
    if (!frame) return false;

    applyTo(frame);
    frame.addEventListener('load', function () {
      applyTo(frame);
    });

    return true;
  }

  if (!hookUp()) {
    // The app embed injects its frame after the theme's scripts have run.
    var observer = new MutationObserver(function () {
      if (hookUp()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
